import { filter, first, map, Observable, of, tap } from 'rxjs';
import { StartupState } from '../startup.state';
import { AUTH_CLIENT_TOKEN, AuthClientProvider, Log, USER_DATA_TOKEN, UserDataProvider } from '@core';
import { inject } from '@angular/core';
import { StartupStep } from '../startup-step';

export class ConnectAuthStep extends StartupStep {
  private readonly authClientProvider: AuthClientProvider = inject(AUTH_CLIENT_TOKEN);
  private readonly userDataProvider: UserDataProvider = inject(USER_DATA_TOKEN);

  executeStep(state: StartupState): Observable<StartupState> {
    this.logger.log(Log.Startup, { message: 'ConnectAuthStep START' });
    return this.authClientProvider.isAuthed$.pipe(
      filter(Boolean),
      first(),
      tap(() => (state.authed$ = of(true))),
      tap(() => this.userDataProvider.setUserData()),
      tap(() => this.logger.log(Log.Startup, { message: 'ConnectAuthStep COMPLETED' })),
      map(() => state)
    );
  }
}
